var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["contactum-field-columns", "has-columns-" + _vm.field.columns] },
    [
      _c("div", { staticClass: "contactum-column-field-inner-columns" }, [
        _c(
          "div",
          { staticClass: "contactum-column" },
          _vm._l(_vm.columnClasses, function(column) {
            return _c(
              "div",
              {
                class: [
                  column,
                  "items-of-column-" + _vm.field.columns,
                  "contactum-column-inner-fields"
                ],
                style: {
                  width: _vm.field.inner_columns_size[column],
                  paddingRight: _vm.field.column_space + "px"
                }
              },
              [
                _c(
                  "ul",
                  { staticClass: "contactum-column-fields-sortable-list" },
                  _vm._l(_vm.column_fields[column], function(field, index) {
                    return _c(
                      "li",
                      {
                        key: field.id,
                        class: [
                          "column-field-items",
                          "contactum-el",
                          field.name,
                          field.css,
                          "form-field-" + field.template,
                          field.width ? "field-size-" + field.width : "",
                          parseInt(_vm.editing_form_id) === parseInt(field.id)
                            ? "current-editing"
                            : ""
                        ],
                        attrs: {
                          "column-field-index": index,
                          "in-column": column,
                          "data-source": "column-field-stage"
                        }
                      },
                      [
                        !_vm.is_full_width(field.template)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "contactum-label contactum-column-field-label"
                              },
                              [
                                !_vm.is_invisible(field)
                                  ? _c(
                                      "label",
                                      {
                                        attrs: {
                                          for:
                                            "contactum-" + field.name
                                              ? field.name
                                              : "cls"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(field.label) +
                                            " "
                                        ),
                                        field.required &&
                                        "yes" === field.required
                                          ? _c(
                                              "span",
                                              { staticClass: "required" },
                                              [_vm._v("*")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("form_" + field.template, {
                          tag: "component",
                          attrs: { field: field }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "contactum-column-field-control-buttons"
                          },
                          [
                            _c("p", [
                              _c("i", { staticClass: "fa fa-arrows move" }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-pencil",
                                on: {
                                  click: function($event) {
                                    return _vm.open_column_field_settings(
                                      field,
                                      index,
                                      column
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-clone",
                                on: {
                                  click: function($event) {
                                    return _vm.clone_column_field(
                                      field,
                                      index,
                                      column
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-trash-o",
                                on: {
                                  click: function($event) {
                                    return _vm.delete_column_field(
                                      index,
                                      column
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }